<template>
  <div>
    <el-descriptions v-loading="isLoading" title="商单信息" border :column="2">
      <el-descriptions-item label="商单编号">{{ order?.number }}</el-descriptions-item>
      <el-descriptions-item label="商品类别">{{ order?.productType }}</el-descriptions-item>
      <el-descriptions-item label="商品名称" :span="2">{{ order?.productName }}</el-descriptions-item>
      <el-descriptions-item label="商品单价">{{ order?.productPrice }}</el-descriptions-item>
      <el-descriptions-item label="总价">{{ order?.price }}</el-descriptions-item>
      <el-descriptions-item label="学员姓名">{{ order?.customerName }}</el-descriptions-item>
      <el-descriptions-item label="联系电话">{{ order?.phone }}</el-descriptions-item>
      <el-descriptions-item label="创建时间">{{ order?.createTime }}</el-descriptions-item>
      <el-descriptions-item label="订单状态">{{ orderStatus }}</el-descriptions-item>
      <el-descriptions-item label="封面图片" :span="2">
        <cloud-img :url="order?.cover" :img-height="100" :img-width="100"></cloud-img>
      </el-descriptions-item>
      <el-descriptions-item label="家长端二维码" :span="2">
        <cloud-img :url="order?.qrM" :img-height="100" :img-width="100"></cloud-img>
      </el-descriptions-item>
    </el-descriptions>

    <div class="title">支付信息</div>
    <el-descriptions v-if="order?.paymentDetail?.paymentMethod !== null" border :column="2">
      <el-descriptions-item label="支付方式">{{ order?.paymentDetail?.paymentMethod }}</el-descriptions-item>
      <template v-if="order?.paymentDetail?.paymentMethod === 'WECHAT'">
        <el-descriptions-item label="支付金额">{{
            order?.paymentDetail?.wechatPaymentInfo?.amount
          }}
        </el-descriptions-item>
        <el-descriptions-item label="微信交易ID">{{
            order?.paymentDetail?.wechatPaymentInfo?.transactionId
          }}
        </el-descriptions-item>
        <el-descriptions-item label="支付时间">{{
            order?.paymentDetail?.wechatPaymentInfo?.paymentTime
          }}
        </el-descriptions-item>
      </template>
      <template v-else>
        <el-descriptions-item label="支付金额">{{
            order.paymentDetail?.otherPaymentInfo.amount
          }}
        </el-descriptions-item>
        <el-descriptions-item label="支付时间">{{
            order.paymentDetail?.otherPaymentInfo.paymentTime
          }}
        </el-descriptions-item>
        <el-descriptions-item label="付款方">{{
            order.paymentDetail?.otherPaymentInfo.payer
          }}
        </el-descriptions-item>
        <el-descriptions-item label="收款方">{{
            order.paymentDetail?.otherPaymentInfo.receiver
          }}
        </el-descriptions-item>
        <el-descriptions-item label="备注">{{
            order.paymentDetail?.otherPaymentInfo.remark
          }}
        </el-descriptions-item>
      </template>
    </el-descriptions>

    <sale-order-timeline :step-items="order?.timelineItems" class="timeline"></sale-order-timeline>
  </div>
</template>

<script>
import {saleorder} from "@/api/saleorder";
import SaleOrderTimeline from "@/components/saleOrder/SaleOrderTimeline.vue";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";

export default {
  name: 'SaleOrderDetail',
  components: {CloudImg, SaleOrderTimeline},
  props: {
    id: Number
  },

  data() {
    return {
      order: {},
      isLoading:false
    };
  },

  computed: {
    orderStatus() {
      const statusMap = {
        1: '待支付',
        2: '已支付',
        3: '已完成',
        4: '已取消',
      };
      return statusMap[this.order?.status] || '未知状态';
    }
  },

  created() {
    this.getDetail();
  },

  methods: {
    getDetail() {
      this.isLoading = true;
      saleorder?.detail(this.id).then(vo => {
        this.isLoading = false;
        return this.order = vo;
      });
    },
  },
};
</script>

<style scoped>
.timeline {
  margin-top: 25px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  margin: 12px auto 8px;
}
</style>
